// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove o quadrado de fundo dos ícones personalizados */
.custom-marker-aluno {
    background: transparent !important;
    border: none !important;
}

/* Estilo para a legenda flutuante */
.mapa-legenda {
    position: absolute;
    top: 10px;
    right: 10px;
    background: white;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    /* Garante que fique acima do mapa */
    max-height: 90vh;
    overflow-y: auto;
    font-family: sans-serif;
    width: 200px;
}

.legenda-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    cursor: pointer;
    padding: 2px;
    border-radius: 4px;
}

.legenda-item:hover {
    background-color: #f0f0f0;
}

.legenda-cor {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    margin-right: 8px;
    border: 1px solid #ccc;
}

/* Remove o fundo invisível do wrapper padrão do Leaflet */
.custom-cluster-wrapper {
    background: transparent;
    border: none;
}

/* Base da bolinha do cluster */
.custom-cluster-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: white;
    font-weight: bold;
    font-family: sans-serif;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    border: 3px solid rgba(255, 255, 255, 0.5);
    /* Borda semi-transparente bonita */
}

/* Tamanhos e Cores baseados na quantidade de alunos */

/* Até 50 alunos */
.cluster-pequeno {
    background-color: rgba(46, 204, 113, 0.9);
    /* Verde */
    width: 20px;
    height: 20px;
    font-size: 12px;
    color: #333;
}

/* De 51 a 200 alunos */
.cluster-medio {
    background-color: rgba(241, 196, 15, 0.9);
    /* Amarelo */
    width: 25px;
    height: 25px;
    font-size: 12px;
    color: #333;
    /* Texto escuro para contrastar com amarelo */
}

/* Mais de 200 alunos */
.cluster-grande {
    background-color: rgba(231, 76, 60, 0.9);
    /* Vermelho */
    width: 30px;
    height: 30px;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA,0DAA0D;AAC1D;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,uCAAuC;IACvC,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA,sDAAsD;;AAEtD,kBAAkB;AAClB;IACI,yCAAyC;IACzC,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,yCAAyC;IACzC,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,6CAA6C;AACjD;;AAEA,uBAAuB;AACvB;IACI,wCAAwC;IACxC,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;AACnB","sourcesContent":["/* Remove o quadrado de fundo dos ícones personalizados */\n.custom-marker-aluno {\n    background: transparent !important;\n    border: none !important;\n}\n\n/* Estilo para a legenda flutuante */\n.mapa-legenda {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: white;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    z-index: 1000;\n    /* Garante que fique acima do mapa */\n    max-height: 90vh;\n    overflow-y: auto;\n    font-family: sans-serif;\n    width: 200px;\n}\n\n.legenda-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n    cursor: pointer;\n    padding: 2px;\n    border-radius: 4px;\n}\n\n.legenda-item:hover {\n    background-color: #f0f0f0;\n}\n\n.legenda-cor {\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    margin-right: 8px;\n    border: 1px solid #ccc;\n}\n\n/* Remove o fundo invisível do wrapper padrão do Leaflet */\n.custom-cluster-wrapper {\n    background: transparent;\n    border: none;\n}\n\n/* Base da bolinha do cluster */\n.custom-cluster-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    color: white;\n    font-weight: bold;\n    font-family: sans-serif;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n    border: 3px solid rgba(255, 255, 255, 0.5);\n    /* Borda semi-transparente bonita */\n}\n\n/* Tamanhos e Cores baseados na quantidade de alunos */\n\n/* Até 50 alunos */\n.cluster-pequeno {\n    background-color: rgba(46, 204, 113, 0.9);\n    /* Verde */\n    width: 20px;\n    height: 20px;\n    font-size: 12px;\n    color: #333;\n}\n\n/* De 51 a 200 alunos */\n.cluster-medio {\n    background-color: rgba(241, 196, 15, 0.9);\n    /* Amarelo */\n    width: 25px;\n    height: 25px;\n    font-size: 12px;\n    color: #333;\n    /* Texto escuro para contrastar com amarelo */\n}\n\n/* Mais de 200 alunos */\n.cluster-grande {\n    background-color: rgba(231, 76, 60, 0.9);\n    /* Vermelho */\n    width: 30px;\n    height: 30px;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
